// react
import React, { useEffect, useState } from 'react';
// components
import { Input, message } from 'antd';
// apis & store & utils
import { renderServiceDegreeComp } from './ViewUtils';
import { withRouter } from 'react-router-dom';



// assets
import '../assets/css/bookingDetail.less';
import sad from '../assets/images/sad.png';
import selectedSad from '../assets/images/selected_sad.png';
import happy from '../assets/images/happy.png';
import selectedHappy from '../assets/images/selected_happy.png';
import satisfy from '../assets/images/satisfy.png';
import selectedSatisfy from '../assets/images/selected_satisfy.png';

/**
 * @description booking detail 评价
 * @param {*} props
 * @returns {*} booking detail
 */

const BookingEvaluateDetail = (props) => {

    const { TextArea } = Input;

    // 满意程度列表
    const serviceDegreeGroup = [
        {
            url: sad,
            selectedUrl: selectedSad,
            desc: '不满意',
        },
        {
            url: happy,
            selectedUrl: selectedHappy,
            desc: '满意',
        },
        {
            url: satisfy,
            selectedUrl: selectedSatisfy,
            desc: '非常满意',
        },
    ];
    // 私教态度列表
    const serviceAttitudeGroup = ['不好', '一般', '很赞'];

    // 问题解决列表
    const serviceQuestionGroup = ['未解决', '已解决', '超出预期'];


    // 选中的满意程度
    const [selectedServiceDegree, setSelectedServiceDegree] = useState(undefined);

    // 选中的私教态度
    const [selectedServiceAttitude, setSelectedServiceAttitude] = useState(undefined);

    // 选中的问题解决
    const [selectedServiceQuestion, setSelectedServiceQuestion] = useState(undefined);

    // 提交的服务建议
    const [serviceAdvice, setServiceAdvice] = useState('');

    /**
     * @description 提交数据给父组件
     */
    const handlePropData = () => {
        props.commitData({
            id: props.bookingDetailId,
            isLike: selectedServiceDegree,
            teachAttitude: selectedServiceAttitude,
            resolveResult: selectedServiceQuestion,
            studentComment: serviceAdvice,
            evaluationSource: 0,
        });
    };

    /**
     * @description 改变状态
     */
    useEffect(() => {
        handlePropData();
    }, [selectedServiceDegree, selectedServiceAttitude, selectedServiceQuestion, serviceAdvice]);

    /**
     * @description 生命周期 api请求
     */
    useEffect(() => {
    }, []);


    /**
     * @description item
     */

    return (
        <div>
            <div className="detail-form">
                <div className="detail-row clear">
                    <div className="row-label fl">满意程度：</div>
                    <div className="row-content fl">
                        {
                            serviceDegreeGroup.map((item, key) => (
                                <a
                                    className="service-face fl"
                                    key={key}
                                    onClick={() => setSelectedServiceDegree(key + 1)}
                                >
                                    <img src={selectedServiceDegree === key + 1 ? item.selectedUrl : item.url} />
                                    <div className={selectedServiceDegree === key + 1 && key === 0 ? 'sad' : selectedServiceDegree === key + 1 && key === 1 ? 'happy' : selectedServiceDegree === key + 1 && key === 2 ? 'satisfy' : 'service-content'}>{item.desc}</div>
                                </a>
                            ))
                        }
                    </div>
                </div>
                <div className="detail-row mt16 clear">
                    <div className="row-label fl">私教态度：</div>
                    <div className="row-content fl">
                        {
                            serviceAttitudeGroup.map((item, key) => (
                                <a
                                    className={selectedServiceAttitude === key + 1 ? 'service-btn btn-selected fl' : 'service-btn fl'}
                                    key={key}
                                    onClick={() => setSelectedServiceAttitude(key + 1)}
                                >
                                    <div className={selectedServiceAttitude === key + 1 ? 'content-selected' : 'service-content'}>{item}</div>
                                </a>
                            ))
                        }
                    </div>
                </div>
                <div className="detail-row mt16 clear">
                    <div className="row-label fl">问题解决：</div>
                    <div className="row-content fl">
                        {
                            serviceQuestionGroup.map((item, key) => (
                                <a
                                    className={selectedServiceQuestion === key + 1 ? 'service-btn btn-selected fl' : 'service-btn fl'}
                                    key={key}
                                    onClick={() => setSelectedServiceQuestion(key + 1)}
                                >
                                    <div className={selectedServiceQuestion === key + 1 ? 'content-selected' : 'service-content'}>{item}</div>
                                </a>
                            ))
                        }
                    </div>
                </div>
                <div className="detail-row mt16 pb45 clear">
                    <div className="row-label fl">服务建议：</div>
                    <div className="row-content fl">
                        <TextArea
                            maxLength={200}
                            onChange={e => setServiceAdvice(e.target.value)}
                            placeholder="为了让老师可以以后更好地为您服务，建议同学能留下宝贵的建议"
                            rows={4}
                            style={{ width: 354 }}
                            value={serviceAdvice} />
                    </div>
                </div>
            </div>
            {renderServiceDegreeComp(props.bookingDetail)}
        </div>
    );
};

export default withRouter(BookingEvaluateDetail);